import '@aofl/drawer';

export default (ctx, html) => html`
  <aofl-drawer id="drawer" ?open="${ctx.sidePanelActive}" opening="${ctx.openClass}" closing="${ctx.closeClass}" trigger="animate">
    <div id="drawer-wrapper">
      <slot></slot>
    </div>
  </aofl-drawer>

  <template class="close-left animate open-left close-right open-right.animate"></template>
`;
